import React from 'react'
import { toast } from 'react-toastify'
import Moment from 'moment'

import snoozePerson from '../../actions/snoozePerson'
import createTouch from '../../actions/createTouch'
import deletePerson from '../../actions/deletePerson'
import updatePerson from '../../actions/updatePerson'
import IntervalChanger from './IntervalChanger'
import PhoneChanger from './PhoneChanger'
import SnoozeStatus from './SnoozeStatus'
import SnoozeToast from './SnoozeToast'
// import TouchHistory from './TouchHistory'
import LastTouch from './LastTouch'
import PhoneActionButtons from './PhoneActionButtons'
import {
  TextInputClickToEdit,
} from '../../styles/forms'
import {
  AppAction,
} from '../../styles/links'
import {
  Badge,
} from '../../styles/badges'
import {
  ActionButton,
  ActionButtonLabel,
} from '../../styles/buttons'

const Person = ({person, history}) => (
  <div>
    <div style={{display: 'grid', gridTemplateColumns: 'auto max-content', }}>
      <TextInputClickToEdit
        type="text"
        autoComplete="off"
        value={person ? person.name : ''}
        onChange={event => updatePerson(person.id, {name: event.target.value})}
        placeholder="Name"
        large
      />
      <PhoneActionButtons person={person} />
    </div>
    
    <Badge>{Moment(person.nextScheduledTouch).format('MMM Do')}</Badge>
    <ActionButton orange onClick={() => {
      snoozePerson(person.id, Moment().add(7, 'days').toDate())
        .then( () => toast(<SnoozeToast person={person} history={history} />))
    }}>
      <ion-icon name="time"></ion-icon>
      <ActionButtonLabel>snooze</ActionButtonLabel>
    </ActionButton>

    <SnoozeStatus person={person} />

    <hr />

    <LastTouch person={person} />
    <ActionButton green onClick={() => {
      createTouch({personId: person.id})
        .then( () => toast(`Nice!`))
    }}>
      <ion-icon name="checkmark"></ion-icon>
      <ActionButtonLabel>log convo</ActionButtonLabel>      
    </ActionButton>

    <hr />

    <IntervalChanger person={person} />

    <hr />

    <PhoneChanger person={person} />

    <hr />

    <AppAction
      light
      onClick={() => {
        if (window.confirm(`Remove ${person.name}? You can't undo this!`)) {
          deletePerson(person)
            .then( () => toast(`Deleted ${person.name}!`))
            .then( () => history.push(`/`))
        }
      }}
    >
      Remove {person.name}
    </AppAction>

  </div>
)

export default Person



// WEBPACK FOOTER //
// ./src/views/person/Person.js